import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import CheckboxView from '../CheckboxView/CheckboxView.js';
import ErrorMessage from '../ErrorMessage/ErrorMessage.js';

/**
 *  A Checkbox component with Label and Error message support
 *
 *  It should be used as replacement for elements/Checkbox component
 *
 *  @Props : CheckboxViewProps, ErrorProps
 */ const CheckboxWithLabel = (_param)=>{
    var { className , checkboxClassName  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "checkboxClassName"
    ]);
    var ref;
    const errorIdFromMsg = rest.errorMessage ? `error_${(ref = rest.errorMessage) === null || ref === void 0 ? void 0 : ref.replace(/[^A-Z0-9]/gi, '_')}` : undefined;
    const errorId = (rest.id ? `error_${rest.id}` : undefined) || errorIdFromMsg;
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames('checkbox-with-label', className)
    }, /*#__PURE__*/ React.createElement(CheckboxView, swcHelpers.extends({}, rest, {
        errorId: errorId,
        className: checkboxClassName
    })), /*#__PURE__*/ React.createElement(ErrorMessage, {
        id: errorId || '',
        error: rest.error,
        errorMessage: rest.errorMessage
    }));
};

export { CheckboxWithLabel as default };
//# sourceMappingURL=CheckboxWithLabel.js.map
